// src/Informes/Components/Pagination.js
import React from "react";
import ReactPaginate from "react-paginate";

const Pagination = ({ pageCount, onPageChange }) => (
  <ReactPaginate
    pageCount={pageCount}
    onPageChange={onPageChange}
    breakLabel="..."
    nextLabel="Siguiente 🢂"
    pageRangeDisplayed={3}
    marginPagesDisplayed={2}
    previousLabel="🢀 Anterior"
    containerClassName="pagination"
    activeClassName="active"
    pageClassName="page-item"
    nextClassName="page-item"
    previousClassName="page-item"
    disabledClassName="disabled"
  />
);

export default Pagination;
